import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
    selector: 'team-carousel',
    templateUrl: 'team-carousel.component.html',
    styleUrls: ['team-carousel.component.scss']
})
export class TeamCarouselComponent implements OnInit {
  @Input() temamembers: any[] = [];
  @Input() currentLang: string = 'en';

  groupedMembers: any[][] = [];
  private itemsPerSlide = 4;

  ngOnInit(): void {
    this.setItemsPerSlide();
    this.buildGroups();
  }

  @HostListener('window:resize')
  onResize(): void {
    const prev = this.itemsPerSlide;
    this.setItemsPerSlide();
    if (prev !== this.itemsPerSlide) {
      this.buildGroups();
    }
  }

  private setItemsPerSlide(): void {
    const width = window.innerWidth;
    if (width < 576) this.itemsPerSlide = 1;
    else if (width < 992) this.itemsPerSlide = 2;
    else this.itemsPerSlide = 4;
  }

  private buildGroups(): void {
    this.groupedMembers = [];
    for (let i = 0; i < this.temamembers.length; i += this.itemsPerSlide) {
      this.groupedMembers.push(this.temamembers.slice(i, i + this.itemsPerSlide));
    }
  }
}